module.exports = __webpack_public_path__ + "img/1a.a067257d.jpg";